import { render, staticRenderFns } from "./ChadeMulheres.vue?vue&type=template&id=d839994e&scoped=true"
import script from "./ChadeMulheres.vue?vue&type=script&lang=js"
export * from "./ChadeMulheres.vue?vue&type=script&lang=js"
import style0 from "./ChadeMulheres.vue?vue&type=style&index=0&id=d839994e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d839994e",
  null
  
)

export default component.exports